import { render } from "./TheInvoicesList.vue?vue&type=template&id=78afd173"
import script from "./TheInvoicesList.vue?vue&type=script&lang=js"
export * from "./TheInvoicesList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__